export const choseToggle = (loading, toggle) => {
  return loading ? () => {} : toggle;
};
